import { __ } from '@wordpress/i18n';
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

import Inspector from './InspectorControls';
import Ring from './ring';
import { getWrapperClasses, getWrapperStyles } from './styles';
import './style.scss';

/**
 * Circular Badge — a phrase set around a circle, wrapped around a centre.
 *
 * The ring belongs to this block: it is chrome, and it can only exist as one
 * string laid along an SVG path, so it is an attribute rather than an inner
 * block. What sits *inside* the ring genuinely varies — a heart on a thank-you
 * seal, a discount on a sale stamp, a logo on a trust mark — so that is inner
 * blocks. Same split as Medal.
 */

/**
 * Inserted with something already in the middle: an empty badge is a ring
 * around nothing, and the centre is the whole point of the composition.
 * Mirrors the block's `example`.
 */
const TEMPLATE = [['brandy/icon', { iconName: 'heart', iconType: 'fill' }]];

export default function Edit({ attributes, setAttributes }) {
  // Frozen on the canvas: text drifting past on a sixteen-second loop cannot be
  // read back or lined up against the controls that change it. Only the class
  // is dropped, so the saved markup is unaffected.
  const blockProps = useBlockProps({
    className: getWrapperClasses({ ...attributes, spin: false }),
    style: getWrapperStyles(attributes),
  });

  // Unlocked: a logo, a number or a short line of text are all reasonable
  // things to wrap. The template is a starting point, not a cage.
  const innerBlocksProps = useInnerBlocksProps(
    { className: 'brandy-circular-badge__centre' },
    { template: TEMPLATE, templateLock: false }
  );

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div {...blockProps}>
        <Ring attributes={attributes} />
        <div {...innerBlocksProps} />
      </div>
    </>
  );
}
